import { defineComponent as a, openBlock as n, createBlock as r, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ a({
  name: "IconUpload",
  __name: "IconUpload",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (n(), r(l(s), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M18 4.75a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5h12m-1.47 6.78a.75.75 0 0 1-1.06 0l-2.72-2.72V20a.75.75 0 0 1-1.5 0V8.81l-2.72 2.72a.75.75 0 0 1-1.06-1.06l3.646-3.647a1.25 1.25 0 0 1 1.768 0l3.646 3.647a.75.75 0 0 1 0 1.06" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
